import React, { Fragment } from "react";
import "./index.css";
import { useHistory } from "react-router-dom";
import { BrowserView, MobileView } from "react-device-detect";
import { Layout, Row, Col, Typography, Button } from "antd";
import {
  InstagramOutlined,
  TwitterOutlined,
  FacebookOutlined,
} from "@ant-design/icons";
import I18n from "../../i18n";

const { Text, Title } = Typography;

export function Footer() {
  const history = useHistory();
  const goTo = (path: string) => history.push(path);

  const renderTitle = () => <Title>{I18n.englishTitle}</Title>;

  const renderSocialIcons = () => (
    <Row justify="space-around">
      <Button type="text" shape="circle" onClick={() => {}}>
        <InstagramOutlined className="footer-social-icon" />
      </Button>
      <Button type="text" shape="circle" onClick={() => {}}>
        <TwitterOutlined className="footer-social-icon" />
      </Button>
      <Button type="text" shape="circle" onClick={() => {}}>
        <FacebookOutlined className="footer-social-icon" />
      </Button>
    </Row>
  );

  const renderCustomerServicesMenu = () => (
    <Fragment>
      <Title level={5} className="footer-menu-title">
        {I18n.footer.customerServices}
      </Title>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/faq")}>
          {I18n.general.faq}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/terms")}>
          {I18n.general.termsAndConditions}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button
          type="text"
          size="small"
          onClick={() => goTo("/privacy-policy")}
        >
          {I18n.general.privacyPolicy}
        </Button>
      </div>
    </Fragment>
  );

  const renderInfoMenu = () => (
    <Fragment>
      <Title level={5} className="footer-menu-title">
        {I18n.footer.info}
      </Title>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/about")}>
          {I18n.general.aboutUs}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Button type="text" size="small" onClick={() => goTo("/contact-us")}>
          {I18n.general.contactUs}
        </Button>
      </div>
      <div className="footer-menu-item">
        <Typography.Text>{I18n.general.support}: 09055212520</Typography.Text>
      </div>
    </Fragment>
  );

  return (
    <Layout.Footer className="footer">
      <BrowserView>
        <Row className="footer-desktop">
          <Col xl={8} md={8}>
            {renderCustomerServicesMenu()}
          </Col>
          <Col xl={8} md={8}>
            {renderInfoMenu()}
          </Col>
          <Col xl={8} md={8}>
            {renderTitle()}
            {renderSocialIcons()}
          </Col>
        </Row>
      </BrowserView>
      <MobileView>
        {renderTitle()}
        {renderSocialIcons()}
        <Row className="footer-mobile">
          <Col span={12}>{renderCustomerServicesMenu()}</Col>
          <Col span={12}>{renderInfoMenu()}</Col>
        </Row>
      </MobileView>
      <div className="footer-copyright-notice">
        <Text>{I18n.footer.copyright.replace("{year}", "1399")}</Text>
      </div>
    </Layout.Footer>
  );
}
